import env from './env'

export const BASE_URL = '/'

export const GRAPHQL_ENDPOINT = env('GRAPHQL_ENDPOINT', '/graphql')
export const DEBUG = process.env.NODE_ENV !== 'production'
export const BUILD_TARGET = process.env.BUILD_TARGET
export const IS_CLIENT = BUILD_TARGET === 'client'
export const IS_SERVER = BUILD_TARGET === 'server'
